import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
	font-size: 20px;
	line-height: 40px;
	position: relative;
	margin-bottom: 15px;
	font-weight: 500;
	letter-spacing: 0.5px;
	color: ${props => 
		props.variant === "blue" ? "#0d609d" :
		props.variant === "white" ? "#ffffff" :
		"#000000"
	};

	&:before{
		content: "";
		top: 0px;
		left: -30px;
		display: block;
		position: absolute;
		width: 8px;
		height: 100%;
		background-color: ${props => 
			props.variant === "blue" ? "#0d609d" :
			props.variant === "white" ? "#ffffff" :
			"#000000"
		};
	}
`;


const SectionTitle = ({title, variant = "blue"}) => {
  return (
    <Wrapper>
		<Title variant={variant}>{title}</Title>        
    </Wrapper>
  )
}

export default SectionTitle;
